import { motion } from "framer-motion";
import { Star } from "lucide-react";

// Testimonials data - add reviews here to display them
// Set SHOW_TESTIMONIALS to true when you have reviews to show
const SHOW_TESTIMONIALS = false;

const testimonials = [
  // Example testimonial format:
  // {
  //   name: "John Smith",
  //   location: "Austin, TX",
  //   rating: 5,
  //   text: "Amazing work on our pool tiles. The calcium buildup was completely removed and our pool looks brand new!",
  //   service: "Pool Tile Calcium Removal",
  // },
];

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0 },
};

const TestimonialsSection = () => {
  // Don't render if no testimonials or toggle is off
  if (!SHOW_TESTIMONIALS || testimonials.length === 0) {
    return null;
  }

  return (
    <section data-testid="testimonials-section" className="py-20 md:py-28">
      <div className="container-custom">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={{
            visible: { transition: { staggerChildren: 0.15 } },
          }}
          className="mb-12"
        >
          <motion.span variants={fadeUp} className="label-accent block mb-4">
            Reviews
          </motion.span>
          <motion.h2
            variants={fadeUp}
            className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-text-primary max-w-3xl"
          >
            What our clients say
          </motion.h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              data-testid={`testimonial-${index}`}
              className="bg-surface border border-white/5 p-6"
            >
              {/* Star Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className={`w-4 h-4 ${
                      i < testimonial.rating
                        ? "text-accent fill-accent"
                        : "text-white/20"
                    }`}
                  />
                ))}
              </div>

              {/* Review Text */}
              <p className="text-text-secondary leading-relaxed mb-6">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="border-t border-white/5 pt-4">
                <p className="font-heading font-bold text-text-primary">
                  {testimonial.name}
                </p>
                <p className="text-text-secondary text-sm">
                  {testimonial.location}
                </p>
                {testimonial.service && (
                  <p className="text-accent text-xs font-mono uppercase tracking-wider mt-2">
                    {testimonial.service}
                  </p>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
